import React, { useContext, useEffect, useState } from "react";
import HTTP from "../../services/httpService";
import { useLocation, useNavigate } from "react-router-dom";
import {
    getStatusEndpoint,
    getNexusColumns,
    LoadingComponent,
} from "./constant";
import CustomTable from "../common/Table";
import NexusHeader from "./NexusHeader";
import { Button, Card, Tabs } from "antd";
import { SettingContext } from "../../routes";
import {
    downloadCSV,
    formatDate,
    getUserRole,
    initialDateRange,
} from "../../services/util";

const { TabPane } = Tabs;

const NexusAgentStatus = () => {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const navigate = useNavigate();
    const location = useLocation();
    const {
        rabbitQueue,
        selectedNexusHotelId,
        setSelectedNexusHotelId,
        selectedNexusDates,
        setSelectedNexusDates,
        callWaitingTab,
        setCallWaitingTab,
    } = useContext(SettingContext);
    const [showSkeleton, setShowSkeleton] = useState(true);
    const [tableData, setTableData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [start_date, end_date] = selectedNexusDates;
    const agentStatusKey = location.state;
    const [sortedInfo, setSortedInfo] = useState({
        order: "descend",
        columnKey: "calls_waiting",
    });
    const [tablePaylod, setTablePaylod] = useState({
        page: 0,
        limit: 10,
        staff_id,
        agent_status: 0,
        all_selected: selectedNexusHotelId.length > 0 ? false : true,
        hotel_ids: [...selectedNexusHotelId],
        need_live_count: callWaitingTab === "history" ? false : true,
        sort_by:
            agentStatusKey === "call_waiting_counts" &&
            callWaitingTab === "history"
                ? sortedInfo.columnKey
                : "",
        sorting:
            agentStatusKey === "call_waiting_counts" &&
            callWaitingTab === "history"
                ? sortedInfo.order === "ascend"
                    ? 2
                    : 1
                : "",
    });

    async function fetchAgentDetails(payload) {
        let statusObject = getStatusEndpoint(agentStatusKey);
        let apiPayload = payload;

        if (statusObject.agent_status) {
            apiPayload.agent_status = statusObject.agent_status;
            delete apiPayload.need_live_count;
            delete apiPayload.start_date;
            delete apiPayload.end_date;
        } else {
            delete apiPayload.agent_status;
        }
        try {
            setShowSkeleton(true);
            let agentDataRes = await HTTP(`nexus/${statusObject.endpoint}`, {
                ...apiPayload,
            });
            if (agentDataRes.success) {
                setTableData(agentDataRes.data);
                setTotalRecords(agentDataRes.total);
                setShowSkeleton(false);
            } else {
                setShowSkeleton(false);
            }
        } catch (error) {
            setShowSkeleton(false);
            console.log("error in fetching agent data", error);
        }
    }

    useEffect(() => {
        const [start_date, end_date] = selectedNexusDates;
        if (agentStatusKey) {
            let tempPayload = { ...tablePaylod };
            if (callWaitingTab === "history") {
                tempPayload.start_date = formatDate(
                    start_date,
                    "YYYY/MM/DD HH:mm:SS",
                );
                tempPayload.end_date = formatDate(
                    end_date,
                    "YYYY/MM/DD HH:mm:SS",
                );
            }
            fetchAgentDetails(tempPayload);
        }
    }, [agentStatusKey, selectedNexusDates]);

    function handlePageChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, columnKey } = sorter;
        let tempPayload = tablePaylod;
        tempPayload.page = current - 1;
        tempPayload.limit = pageSize;
        if (order && columnKey) {
            tempPayload.sorting = order === "ascend" ? 2 : 1;
            tempPayload.sort_by = columnKey;
            setSortedInfo({ order, columnKey });
        } else {
            tempPayload.sorting = 1;
            tempPayload.sort_by = "";
            setSortedInfo({});
        }
        if (callWaitingTab === "history") {
            const [start_date, end_date] = selectedNexusDates;
            tempPayload.start_date = formatDate(
                start_date,
                "YYYY/MM/DD HH:mm:SS",
            );
            tempPayload.end_date = formatDate(end_date, "YYYY/MM/DD HH:mm:SS");
        }
        fetchAgentDetails(tempPayload);
        setTablePaylod({ ...tempPayload });
    }

    function handleFilterChange(hotelIds) {
        let tempPayload = { ...tablePaylod };
        tempPayload.all_selected = hotelIds.length > 0 ? false : true;
        tempPayload.hotel_ids = hotelIds;
        fetchAgentDetails(tempPayload);
        setTablePaylod({ ...tempPayload });
    }

    function updateAgentList() {
        if (rabbitQueue && rabbitQueue?.flag === 102) {
            let isExist = tableData.some(
                (item) => item.staff_id === rabbitQueue.staff_id,
            );
            if (isExist) {
                fetchAgentDetails(tablePaylod);
            } else return;
        } else return;
    }

    useEffect(() => {
        if (rabbitQueue) {
            updateAgentList();
        } else return false;

        return () => {
            setCallWaitingTab("call_waiting");
        };
    }, [rabbitQueue]);

    async function changeView(key_url) {
        const [key] = key_url.split("-");
        setCallWaitingTab(key);
        setSelectedNexusDates(initialDateRange);
        setTableData([]);
        const tablePaylodTemp = {
            ...tablePaylod,
            page: 0,
            limit: 10,
            need_live_count: key === "history" ? false : true,
            sort_by: "",
            sorting: 1,
        };
        if (tablePaylodTemp.start_date) {
            delete tablePaylodTemp.start_date;
            delete tablePaylodTemp.end_date;
        }
        if (key === "history") {
            tablePaylodTemp.start_date = formatDate(
                start_date,
                "YYYY/MM/DD HH:mm:SS",
            );
            tablePaylodTemp.end_date = formatDate(
                end_date,
                "YYYY/MM/DD HH:mm:SS",
            );
            tablePaylodTemp.sort_by = sortedInfo.columnKey;
            tablePaylodTemp.sorting = sortedInfo.order;
        }
        fetchAgentDetails(tablePaylodTemp);
        setTablePaylod({ ...tablePaylodTemp });
    }

    async function downalodReport() {
        const tempFormData = { ...tablePaylod };
        delete tempFormData["page"];
        delete tempFormData["limit"];
        tempFormData.start_date = formatDate(start_date, "YYYY/MM/DD HH:mm:SS");
        tempFormData.end_date = formatDate(end_date, "YYYY/MM/DD HH:mm:SS");
        const res = await HTTP("/nexus/getNexusCallWaitingDetailsReport", {
            ...tempFormData,
        });
        downloadCSV(res, `call_waiting_reports`);
    }

    const handleTableClick = (clickFrom, rowData) => {
        if (
            agentStatusKey === "call_waiting_counts" &&
            callWaitingTab === "history"
        ) {
            navigate(`/nexus-agents-status/call-wating-detail`, {
                state: {
                    hotel_id: rowData.hotel_id,
                    kiosk_id: rowData.kiosk_id,
                    tz_id: rowData.tz_id,
                },
            });
        } else return;
    };

    const NexusTable = () => {
        return (
            <>
                {!showSkeleton ? (
                    <CustomTable
                        columns={getNexusColumns(
                            sortedInfo,
                            agentStatusKey,
                            callWaitingTab,
                            handleTableClick,
                        )}
                        tableData={tableData}
                        noOfrecords={totalRecords || 0}
                        handleTableChange={handlePageChange}
                        rowKey="id"
                        className="dashboard-table"
                        currentPage={tablePaylod.page + 1}
                        currentPageLimit={tablePaylod.limit}
                        isScroll
                    />
                ) : (
                    <LoadingComponent />
                )}
            </>
        );
    };

    const refreshData = () => {
        let tempPayload = { ...tablePaylod };
        if (agentStatusKey === "call_waiting_counts") {
            tempPayload.need_live_count =
                callWaitingTab === "history" ? false : true;
            if (callWaitingTab === "history") {
                tempPayload.start_date = formatDate(
                    start_date,
                    "YYYY/MM/DD HH:mm:SS",
                );
                tempPayload.end_date = formatDate(
                    end_date,
                    "YYYY/MM/DD HH:mm:SS",
                );
            }
        }
        setSortedInfo({});
        fetchAgentDetails(tempPayload);
        setTablePaylod({ ...tempPayload });
        setSelectedNexusHotelId([]);
    };

    return (
        <>
            <NexusHeader
                showBackButton={true}
                isHotelFilter={true}
                handleFilterChange={handleFilterChange}
                selectedHotelId={selectedNexusHotelId}
                setSelectedHotelId={setSelectedNexusHotelId}
                isRefreshAllowed={true}
                showRangePicker={callWaitingTab === "history" ? true : false}
                refreshData={refreshData}
                extraAfter={
                    (getUserRole() == "Super Admin" ||
                        getUserRole() == "Admin" ||
                        getUserRole() == "Management") &&
                    (callWaitingTab === "history" ? (
                        <Button
                            type="primary"
                            className="margin-right-5"
                            onClick={downalodReport}
                        >
                            Download
                        </Button>
                    ) : (
                        ""
                    ))
                }
                withTime={
                    agentStatusKey === "call_waiting_counts" &&
                    callWaitingTab === "history"
                        ? true
                        : false
                }
                selectedDateTime={selectedNexusDates}
                setSelectedDatetime={setSelectedNexusDates}
            />
            {agentStatusKey === "call_waiting_counts" ? (
                <>
                    <Card className="box-shadow margin-10">
                        <Tabs
                            onChange={changeView}
                            destroyOnHidden={true}
                            type="card"
                            defaultActiveKey={callWaitingTab}
                        >
                            <TabPane tab="Call waiting" key="call_waiting">
                                <NexusTable />
                            </TabPane>
                            <TabPane tab="History" key="history">
                                <NexusTable />
                            </TabPane>
                        </Tabs>
                    </Card>
                </>
            ) : (
                <Card className="box-shadow margin-10">
                    <NexusTable />
                </Card>
            )}
        </>
    );
};

export default NexusAgentStatus;
